import AuthRouters from './auth'
import PlansRouter from './plans'
import SitesRouter from './sites'

export default function () {
  this.urlPrefix = 'http://localhost:3000'
  AuthRouters(this)
  this.namespace = '/api/v1'
  PlansRouter(this)
  SitesRouter(this)
}
